import { render, staticRenderFns } from "./atlas_result.vue?vue&type=template&id=ff81083c&scoped=true"
import script from "./atlas_result.vue?vue&type=script&lang=js"
export * from "./atlas_result.vue?vue&type=script&lang=js"
import style0 from "./atlas_result.vue?vue&type=style&index=0&id=ff81083c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff81083c",
  null
  
)

export default component.exports